export const navigateToAppSettingsInMarketplace = (pluginVersionId: string): void => {
  window.open(`${location.origin}/marketplace/applications/settings?pluginVersionId=${pluginVersionId}`, "_self");
};

export const EXISTS_IN_THIS_FIELD = "exists-in-this-field";
export const EXISTS_IN_OTHER_FIELDS = "exists-in-other-fields";
